import type { ChannelStats, ErrorData, MessagesStats } from '@pages/event/api/useFetchMessagesStats';
import type { UnsentErrorChannel } from './types';

const formatCount = (count: number): string => count.toLocaleString('ru-RU');

type UnsentChannelConfig = {
  columnLabel: string;
  getAlertText: (errorCount: number) => string;
  getStats: (messagesStats: MessagesStats) => ChannelStats;
  getContact: (item: ErrorData) => string;
};

const UNSENT_CHANNEL_CONFIG: Record<UnsentErrorChannel, UnsentChannelConfig> = {
  sms: {
    columnLabel: 'ФИО/Телефон',
    getAlertText: (errorCount) => `${formatCount(errorCount)} СМС не отправлено`,
    getStats: (messagesStats) => messagesStats.smsStats,
    getContact: (item) => item.phone || '-',
  },
  email: {
    columnLabel: 'ФИО/E-mail',
    getAlertText: (errorCount) => `${formatCount(errorCount)} e-mail не отправлено`,
    getStats: (messagesStats) => messagesStats.emailStats,
    getContact: (item) => item.email || '-',
  },
  vkTeams: {
    columnLabel: 'ФИО/E-mail',
    getAlertText: (errorCount) => `${formatCount(errorCount)} сообщений VK Teams не отправлено`,
    getStats: (messagesStats) => messagesStats.vkStats,
    getContact: (item) => item.email || '-',
  },
};

export const formatFullName = (item: ErrorData): string => {
  const fullName = [item.lastName, item.firstName].filter(Boolean).join(' ');

  return fullName || '-';
};

export const getUnsentChannelView = (channel: UnsentErrorChannel, messagesStats: MessagesStats) => {
  const config = UNSENT_CHANNEL_CONFIG[channel];
  const stats = config.getStats(messagesStats);

  return {
    columnLabel: config.columnLabel,
    alertText: config.getAlertText(stats.errorCount),
    errorData: stats.errorData,
    getContact: config.getContact,
  };
};
